import { ChevronLeftIcon } from '@chakra-ui/icons'
import { Flex, Center, Box, Heading, HStack, VStack } from '@chakra-ui/layout'
import { Button, Text } from '@chakra-ui/react'
import { FunctionComponent } from 'react'
import { PageEnum } from '.'
import SelectedModel from './selectedModel'

interface IProps {
  page: PageEnum
  onOpen?: () => void
  onClose?: () => void
  setPage: React.Dispatch<React.SetStateAction<PageEnum>>
}

const ThickHeader: FunctionComponent<IProps> = ({
  page,
  onOpen,
  onClose,
  setPage,
}) => {
  return (
    <VStack
      spacing={4}
      align="stretch"
      paddingInline="30px"
      marginBottom="15px"
    >
      {onClose && onOpen && (
        <Box>
          <Button
            variant="link"
            onClick={() => {
              onClose()
              setTimeout(() => {
                setPage(PageEnum.PickYourModel)
                onOpen()
              }, 200)
            }}
            borderRadius="0"
            fontSize="sm"
            color="black"
            fontWeight="normal"
          >
            <ChevronLeftIcon />
            <Text fontSize="sm">Back to models</Text>
          </Button>
        </Box>
      )}
      <Heading as="h1" size="md" isTruncated>
        {page}
      </Heading>
      {/* <SelectedModel /> */}
    </VStack>
  )
}
export default ThickHeader
